import {useQuery, UseQueryOptions} from '@tanstack/react-query';
import {getCustomerMyFavorites} from 'api/requests';
import {ICustomerMyFavoritesResponse, QueryKeyEnum} from 'types';

export const useCustomerMyFavorites = (options?: UseQueryOptions<ICustomerMyFavoritesResponse[]>) => {
  return useQuery<ICustomerMyFavoritesResponse[]>({
    queryKey: [QueryKeyEnum.CUSTOMER_MY_FAVORITES],
    queryFn: () => {
      return getCustomerMyFavorites();
    },
    ...options,
  });
};
